import { reportError } from '@/services/errorReportingApi'

// Co-located in the store (not services/) since it's only ever called *from*
// the store — services must never import the store, but this has no such
// constraint in this direction.
export function reportStoreError(context, error) {
  reportError({ message: error?.message, stack: error?.stack, context })
}
